import { ReactNode } from "react";
import {
    PaginationLabel,
    PaginationWrapper,
} from "../styles/components/Pagination";
import { LeftArrowIcon, RightArrowIcon } from "./Icons";

import { IPagination } from "./IPagination";

interface IPaginationProps {
    pagination: IPagination;
    filterPageSize: number;
    handleChangePage: (actualPage: number) => void;
    children: ReactNode;
}

const PaginationServerSide = ({
    pagination,
    filterPageSize = 10,
    handleChangePage,
    children,
}: IPaginationProps) => {
    const hasNextPage = pagination.actualPage < pagination.totalPages;
    const isBlockedPreviousPage =
        pagination.actualPage === 1 || pagination.totalRecords === 0;
    const isBlockedNextPage = !hasNextPage || pagination.totalRecords === 0;

    const handlePreviousPage = () => {
        if (!isBlockedPreviousPage) {
            handleChangePage(pagination.actualPage - 1);
        }
    };

    const handleNextPage = () => {
        if (hasNextPage) {
            handleChangePage(pagination.actualPage + 1);
        }
    };

    const getInitialItemNumber = () => {
        if (pagination.totalRecords === 0) {
            return 0;
        }

        if (pagination.actualPage === 1) {
            return 1;
        }

        return (pagination.actualPage - 1) * filterPageSize + 1;
    };

    const getLastItemNumber = () => {
        const lastItemIndex = getInitialItemNumber() + filterPageSize;
        return lastItemIndex < pagination.totalRecords
            ? lastItemIndex - 1
            : pagination.totalRecords;
    };

    const handleCursorLeftArrowIcon = () => {
        return isBlockedPreviousPage ? "default" : "pointer";
    };

    const handleFillLeftArrowIcon = () => {
        return isBlockedPreviousPage ? "#C4A0FF" : "#9654FF";
    };

    const handleCursorRightArrowIcon = () => {
        return isBlockedNextPage ? "default" : "pointer";
    };

    const handleFillRightArrowIcon = () => {
        return isBlockedNextPage ? "#C4A0FF" : "#9654FF";
    };

    return (
        <>
            {children}
            <PaginationWrapper>
                <PaginationLabel className="pagination_label_legend">
                    Itens por página: {filterPageSize}
                </PaginationLabel>
                <LeftArrowIcon
                    style={{
                        cursor: handleCursorLeftArrowIcon(),
                        fill: handleFillLeftArrowIcon(),
                        marginRight: "12px",
                    }}
                    onClick={handlePreviousPage}
                />
                <PaginationLabel>
                    {`${getInitialItemNumber()}-${getLastItemNumber()} de ${
                        pagination.totalRecords
                    }`}
                </PaginationLabel>
                <RightArrowIcon
                    style={{
                        cursor: handleCursorRightArrowIcon(),
                        fill: handleFillRightArrowIcon(),
                        marginLeft: "12px",
                        marginRight: "16px",
                    }}
                    onClick={handleNextPage}
                />
            </PaginationWrapper>
        </>
    );
};

export default PaginationServerSide;
